import React from "react";
import ColorCard from "./ColorCard";

const CardsList = (props) => {
  return (
    <div className="row" data-masonry='{"percentPosition": true }'>
      {props.imageList &&
        props.imageList.map((image) => {
          return <ColorCard key={image.id} image={image.path} />;
        })}
    </div>
  );
};

export default CardsList;
